import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { ArrowDown, ArrowUp } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import * as Styles from './styles'

const TableHeaderButton = ({ children, onClick, selected, direction, disabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleClick = () => {
    if (!disabled) {
      onClick()
    }
  }

  return (
    <Tooltip title={t('Cambiar ordenación')} arrow position="bottom" disabled={disabled}>
      <Styles.Container onClick={handleClick} disabled={disabled} selected={selected}>
        {children}
        {direction === 'asc' && selected && <ArrowUp color={theme.colors.outline.default} size={16} alt={direction} />}
        {direction === 'desc' && selected && (
          <ArrowDown color={theme.colors.outline.default} size={16} alt={direction} />
        )}
      </Styles.Container>
    </Tooltip>
  )
}

export default TableHeaderButton
